import React from "react"
import { Container, Row, Col } from "reactstrap"

import bgImage from "../../assets/images/wp10581298-data-mining-wallpapers.jpg";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer" style={{backgroundImage:`url(${bgImage})`, backgroundSize:"cover"}}>
        <Container fluid={true}>
          <Row>
            <div className="col-12" style={{color:"white"}}>
            © {new Date().getFullYear()} TrueFocus Automation.All rights reserved.
            </div>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
